
//* sale banner countdown =================================================== */

// Set the date we're counting down to

function getDigit(num, digit) {
  num = num.toString();
  while (num.length < 2) num = "0" + num;
  return num.toString().split('')[digit];
}

function countdown() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  // document.getElementById('flipcounterDaysA').innerHTML = days + "d " + hours + "h "
  document.getElementById('flipcounterDaysA').innerHTML = getDigit(days, 0);
  document.getElementById('flipcounterDaysB').innerHTML = getDigit(days, 1);
  document.getElementById('flipcounterHoursA').innerHTML = getDigit(hours, 0);
  document.getElementById('flipcounterHoursB').innerHTML = getDigit(hours, 1);
  document.getElementById('flipcounterMinsA').innerHTML = getDigit(minutes, 0);
  document.getElementById('flipcounterMinsB').innerHTML = getDigit(minutes, 1);
  document.getElementById('flipcounterSecsA').innerHTML = getDigit(seconds, 0);
  document.getElementById('flipcounterSecsB').innerHTML = getDigit(seconds, 1);

  // If the count down is finished, write some text
  if (distance <= 0) {
    clearInterval(x);
    window.location.reload();
  }
}

var x = null;
document.addEventListener('DOMContentLoaded', function() {

  // Update the count down every 1 second
  if (typeof countDownDate !== 'undefined') {
    x = setInterval(countdown, 1000);
    countdown();
    document.querySelector('.flip-counter').classList.add('s_active');
  }

}, false);
